import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-191d3817"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "history" };
const _hoisted_2 = { class: "content price" };
const _hoisted_3 = { class: "content size" };
const _hoisted_4 = { class: "content time" };
import { useStore } from '@/store/store';
import { decimalizeByStep, decimalizeByExchange, setTimezone } from '@/logics/utils';
import dayjs from 'dayjs';
import NoData from '@/materials/atoms/NoData.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        histories: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.histories, (history, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["list", `${history.trade} ${history.animation}`]),
                        key: index + String(history.animation)
                    }, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(decimalizeByExchange)(history.price, _unref(store).getters.symbol.pair, _unref(store).state.currencyPairInfo)), 1),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(decimalizeByStep)(history.amount, _unref(store).getters.symbol.base, _unref(store).state.currencyInfo)), 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), `${_unref(dayjs)().format('YYYY-MM-DD')} ${history.time}`, 'HH:mm:ss')), 1)
                    ], 2));
                }), 128)),
                _createVNode(NoData, {
                    isShow: props.histories.length === 0
                }, null, 8, ["isShow"])
            ]));
        };
    }
});
